import React from 'react'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ConfirmDeleteDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  message?: string
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  message
}) => {
  const { t } = useTranslation()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='confirm-delete-dialog-title'
      aria-describedby='confirm-delete-dialog-description'
      PaperProps={{
        sx: {
          width: '552px',
          height: '294px',
          borderRadius: '20px'
        }
      }}
    >
      <DialogTitle
        id='confirm-delete-dialog-title'
        sx={{
          fontFamily: 'Inter',
          fontSize: '24px',
          fontWeight: 700,
          lineHeight: '38.4px',
          textAlign: 'center',
          mt: 4
        }}
      >
        {title || t('confirmDelete.deleteAddress')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id='confirm-delete-dialog-description'
          sx={{
            fontFamily: 'Inter',
            fontSize: '26px',
            fontWeight: 400,
            lineHeight: '32px',
            textAlign: 'center'
          }}
        >
          {message || t('confirmDelete.confirmMessage')}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', mb: 5 }}>
        <Button
          onClick={onClose}
          variant='outlined'
          sx={{
            width: '190px',
            height: '45px',
            borderRadius: '4px',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '16.94px',
            textAlign: 'left',
            marginRight: '16px'
          }}
        >
          {t('confirmDelete.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          sx={{
            width: '190px',
            height: '45px',
            borderRadius: '4px',
            fontFamily: 'Inter',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '16.94px',
            textAlign: 'left',
            borderColor: 'primary.main'
          }}
        >
          {t('confirmDelete.yesDelete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteDialog
